/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppInfoRequest } from '../models/AppInfoRequest';
import type { AppInfoResponse } from '../models/AppInfoResponse';
import type { AppStats } from '../models/AppStats';
import type { AppStatsRequest } from '../models/AppStatsRequest';
import type { AppVersion } from '../models/AppVersion';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AppService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AppInfoResponse
     * @throws ApiError
     */
    public appAppInfoCreate({
        requestBody,
    }: {
        requestBody?: AppInfoRequest,
    }): CancelablePromise<AppInfoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/app/app-info/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AppStats
     * @throws ApiError
     */
    public appAppStatsCreate({
        requestBody,
    }: {
        requestBody?: AppStatsRequest,
    }): CancelablePromise<AppStats> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/app/app-stats/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AppVersion
     * @throws ApiError
     */
    public appVersionRetrieve(): CancelablePromise<AppVersion> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/app/version/',
        });
    }

}
